/**
 * Shared GWI-commission + money formatting so the Pro driver-pay modal and the
 * AddlCostView tables render byte-identical values for the same line item.
 *
 * GWI takes a flat 30% commission out of a driver-pay line item's rate when the
 * item is flagged gwicommission='Y'. Mirrors V1's hardcoded rate*.3 and the
 * backend margin_service. No pre-rounding — round only at format time.
 */

export const GWI_COMMISSION_PCT = 0.3;

/** Commission deducted and net (take-home) rate for a driver-pay line.
 *  Commission applies only when gwiCommission==='Y'. Fuel is added in full
 *  after commission is deducted from the base rate. */
export const gwiCommissionFor = (
  rate: number | null,
  gwiCommission: string,
  fuelAmount = 0,
): { commission: number | null; net: number | null } => {
  if (rate == null) return { commission: null, net: null };
  if (gwiCommission !== 'Y') return { commission: null, net: rate + fuelAmount };
  const commission = rate * GWI_COMMISSION_PCT;
  return { commission, net: rate - commission + fuelAmount };
};

/** Format a number as a 2-decimal money string with locale thousands
 *  separators (matches AddlCostView's money() for non-null values). */
export const formatMoney = (n: number): string =>
  n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
